<template>
  <transition name="fade">
  <div class="question single-option boolean question box box-shadow">

    <div class="question--question" v-html="question"></div>

    <div class="answers row">

      <div v-for="col in partitionedAnwsers" class="col-12 col-sm-6 col-lg-4">
        <div v-for="answer in col" class="row">
          <div class="form-checkbox ">
            <input
                    type="checkbox"
                    :name="index+'-'+answer.id"
                    :id="index+'-'+answer.id"
                    :value="answer.id"
                    v-model="radioButtonValue"
            />
            <label class="small-label" :for="index+'-'+answer.id" v-html="answer.answer"></label>
          </div>
        </div>
      </div>

    </div>
    <footer>Q ID: {{id}} : {{index}}</footer>
  </div>
  </transition>
</template>

<style>
  label{
    padding-right:5px;
  }
  .question .answers {
    margin: 2rem 1rem 0 0rem !important;
  }
</style>
<script>
import Question from '@/components/questions/Question'
export default {
  name: 'MultiOption',
  extends: Question,
  data: function () {
    return {
      temp: []
    }
  },
  computed: {
    radioButtonValue: {
      get: function () {
        return this.value || []
      },
      set: function (val) {
        this.$emit('input', val)
      }
    },
    partitionedAnwsers () {
      let items = this.answers
      let chunkSize = Math.ceil(items.length / 3)

      let groups = []
      for (let i = 0; i < items.length; i += chunkSize) {
        groups.push(items.slice(i, i + chunkSize))
      }
      return groups
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/questions/MultiOption.vue